
export const REQUEST_EDITVIDEONOTE= 'REQUEST_EDITVIDEONOTE';
export const EDITVIDEONOTE_RECEIVED = 'EDITVIDEONOTE_RECEIVED';